import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Dumbbell, Activity, Bike, Target } from 'lucide-react';
import { equipmentData, facilityImages } from '../data/mock';

const iconMap = {
  freeWeights: Dumbbell,
  machines: Target,
  cardio: Bike,
  functional: Activity,
};

export const Equipment = () => {
  return (
    <section id="equipment" className="py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            <span className="text-[#39FF14]">Equipament</span> Complet
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Disposem de tot el que necessites per als teus entrenaments de cardio i força
          </p>
        </div>

        {/* Facility Images */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          {facilityImages.map((image) => (
            <div key={image.id} className="relative overflow-hidden rounded-2xl group">
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-80 object-cover transform group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                <p className="text-white font-bold text-lg">{image.alt}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Equipment Categories */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {Object.entries(equipmentData).map(([key, category]) => {
            const Icon = iconMap[key];
            return (
              <Card
                key={key}
                className="bg-gray-900/50 border-2 border-gray-800 hover:border-[#39FF14] transition-all duration-300 hover:shadow-xl hover:shadow-[#39FF14]/20 group"
              >
                <CardHeader>
                  <CardTitle className="flex items-center gap-3 text-white group-hover:text-[#39FF14] transition-colors">
                    <Icon className="w-8 h-8" />
                    {category.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {category.items.map((item, index) => (
                      <li key={index} className="flex items-start gap-2 text-gray-400">
                        <span className="text-[#39FF14] mt-1">•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Extra Info */}
        <div className="mt-12 text-center bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 border border-[#39FF14]/20">
          <p className="text-gray-300 text-lg">
            <span className="text-[#39FF14] font-bold">I molt més!</span> La nostra sala està completament equipada
            per oferir-te la millor experiència d'entrenament
          </p>
        </div>
      </div>
    </section>
  );
};
